if (!customElements.get('endless-collection')) {
  class EndlessCollection extends HTMLElement {
    // Selectors.
    selectors = {
      loadMoreButton: '[data-load-more]',
      loadMoreContainer: '[data-load-more-container]',
      items: '[data-collection-items]',
      item: '[data-collection-item]',
      target: '[data-load-more-target]',
    };
    observer = null;
    observerConfig = {
      rootMargin: '300px 0px 0px 0px',
    };
    static parser = new DOMParser();

    /**
     * Constructor.
     */
    constructor() {
      super();
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        this.observerConfig,
      );
      this.target = this.querySelector(this.selectors.target);
      this.url = this.target.getAttribute('data-load-more-url');
      this.observer.observe(this.target);
    }

    handleIntersection(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.fetchItems();
          this.observer.unobserve(this.target);
        }
      });
    }

    /**
     * Click event handler.
     *
     * @param {Event} e
     * @returns {void}
     */
    async fetchItems() {
      const nextUrl = this.target.getAttribute('data-load-more-url');

      const { items, target } = await this.getNextPageMarkup(nextUrl);

      for (const item of items) {
        this.querySelector(this.selectors.items).appendChild(item);
      }

      if (target) {
        this.target.replaceWith(target);
        this.target = target;
        this.observer.observe(target);
      } else {
        this.querySelector(this.selectors.loadMoreContainer).remove();
      }
    }

    /**
     * Gets items from an URL.
     *
     * @param {String} url
     * @returns {Object} - { items: NodeList, button: Node }
     */
    async getNextPageMarkup(url) {
      this.target.setAttribute('is-loading', true);

      const response = await fetch(url);
      const data = await response.text();
      const html = EndlessCollection.parser.parseFromString(data, 'text/html');

      this.target.removeAttribute('is-loading');

      return {
        items: html.documentElement.querySelectorAll(this.selectors.item),
        target: html.documentElement.querySelector(this.selectors.target),
      };
    }
  }
  customElements.define('endless-collection', EndlessCollection);
}
